module.exports = __webpack_public_path__ + "img/logos-mobile.89905a9.png";